<div class="search-field-wrapper"
     [class.search-field-focused]="isSearchFocused"
     [style.max-width]="maxWidth">
  <mat-icon class="search-icon">search</mat-icon>
  <input
    type="text"
    class="search-input"
    [placeholder]="placeholder"
    [value]="value"
    [disabled]="disabled"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    [attr.aria-label]="ariaLabel"
  />
  <button
    *ngIf="value"
    type="button"
    class="clear-button"
    (click)="clearSearch()"
    aria-label="Clear search"
  >
    <mat-icon class="clear-icon">close</mat-icon>
  </button>
</div>
